import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { UserStateService } from '../../../core/services/user-state.service';

@Component({
  standalone: true,
  selector: 'app-auth-header',
  imports: [CommonModule, RouterModule],
  template: `
    <header class="bg-white shadow-sm border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <!-- Logo and Brand -->
          <a [routerLink]="['/']" class="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <div class="relative">
              <img src="/logos/wsy-yardBull-Icon.png" alt="Wall St. Yardie Logo" class="h-10 w-10 drop-shadow-sm">
              <div class="absolute -inset-1 bg-jamaica-gold-400/20 rounded-full blur-sm -z-10"></div>
            </div>
            <h1 class="text-2xl font-bold text-jamaica-green-700 tracking-tight">
              Wall St. Yardie
            </h1>
          </a>

          <!-- Sign Out Button -->
          <button
            (click)="signOut()"
            class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-green-600 hover:text-jamaica-green-700 hover:bg-yellow-100 rounded-lg transition-colors">
            <i class="pi pi-sign-out"></i>
            Sign Out
          </button>
        </div>
      </div>
    </header>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthHeaderComponent {
  constructor(
    private auth: AuthService,
    private userStateService: UserStateService
  ) {}

  signOut(): void {
    this.userStateService.clearState();
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }
}
